"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSponsoredRewardRequestToJSON = exports.CreateSponsoredRewardRequestFromJSONTyped = exports.CreateSponsoredRewardRequestFromJSON = void 0;
var _1 = require("./");
function CreateSponsoredRewardRequestFromJSON(json) {
    return CreateSponsoredRewardRequestFromJSONTyped(json, false);
}
exports.CreateSponsoredRewardRequestFromJSON = CreateSponsoredRewardRequestFromJSON;
function CreateSponsoredRewardRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'winningCriteria': (0, _1.WinningCriteriaFromJSON)(json['winningCriteria']),
        'rewardConfigId': json['rewardConfigId'],
    };
}
exports.CreateSponsoredRewardRequestFromJSONTyped = CreateSponsoredRewardRequestFromJSONTyped;
function CreateSponsoredRewardRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'winningCriteria': (0, _1.WinningCriteriaToJSON)(value.winningCriteria),
        'rewardConfigId': value.rewardConfigId,
    };
}
exports.CreateSponsoredRewardRequestToJSON = CreateSponsoredRewardRequestToJSON;
